import { createContext } from "react";
import { IContextArea } from "../types/area.interface";

const AreaScreen = createContext<IContextArea>({});

export default AreaScreen;
